var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDotsVertical = function SvgDotsVertical(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 21.029q-.684 0-1.17-.487a1.6 1.6 0 0 1-.487-1.17q0-.683.487-1.17a1.6 1.6 0 0 1 1.17-.487q.684 0 1.17.487.487.487.487 1.17 0 .684-.487 1.17a1.6 1.6 0 0 1-1.17.487m0-7.372q-.684 0-1.17-.487a1.6 1.6 0 0 1-.487-1.17q0-.684.487-1.17a1.6 1.6 0 0 1 1.17-.487q.684 0 1.17.487.487.486.487 1.17t-.487 1.17a1.6 1.6 0 0 1-1.17.487m0-7.372q-.684 0-1.17-.487a1.6 1.6 0 0 1-.487-1.17q0-.684.487-1.17A1.6 1.6 0 0 1 12 2.97q.684 0 1.17.487.487.486.487 1.17 0 .682-.487 1.17a1.6 1.6 0 0 1-1.17.487"
  })));
};
export default SvgDotsVertical;